import { showErrorToast, showSuccessToast } from '@/utils/toasts/Toasts';

// Helper function to get display name for toast messages
const getToastFolderName = (folderKey: string, folderDisplayName: string): string => {
  // Show "Document Set" for root folder instead of folder name or "/"
  if (folderKey === 'root' || folderDisplayName === '/' || folderDisplayName === 'root') {
    return 'Document Set';
  }
  return folderDisplayName;
};

// Helper function for move operation toast notifications
export const showMoveToast = (
  data: { movedFiles?: number; duplicateFiles?: string[] } | undefined,
  targetFolderKey: string,
  targetFolderName: string,
) => {
  const displayName = getToastFolderName(targetFolderKey, targetFolderName);
  const movedCount = data?.movedFiles ?? 0;
  const duplicateCount = data?.duplicateFiles?.length ?? 0;

  if (movedCount === 0 && duplicateCount > 0) {
    showErrorToast(
      `All ${duplicateCount} file${duplicateCount !== 1 ? 's were' : ' was'} already in ${displayName}.`,
    );
  } else if (movedCount === 0) {
    showErrorToast(`No files were moved to ${displayName}.`);
  } else if (duplicateCount > 0) {
    showSuccessToast(
      `Moved ${movedCount} file${movedCount !== 1 ? 's' : ''} to ${displayName}. ${duplicateCount} file${duplicateCount !== 1 ? 's' : ''} already existed.`,
    );
  } else {
    showSuccessToast(
      `Successfully moved ${movedCount} file${movedCount !== 1 ? 's' : ''} to ${displayName}.`,
    );
  }
};

// Helper function for copy operation toast notifications
export const showCopyToast = (
  data: { copiedFiles?: number; duplicateFiles?: string[] } | undefined,
  targetFolderKey: string,
  targetFolderName: string,
  requestedCount: number,
) => {
  const displayName = getToastFolderName(targetFolderKey, targetFolderName);

  if (data?.duplicateFiles && data.duplicateFiles.length > 0) {
    const copiedCount = data.copiedFiles || 0;
    const duplicateCount = data.duplicateFiles.length;
    if (copiedCount > 0) {
      showSuccessToast(
        `Copied ${copiedCount} file${copiedCount !== 1 ? 's' : ''} to ${displayName}. ${duplicateCount} file${duplicateCount !== 1 ? 's' : ''} already existed.`,
      );
    } else {
      showErrorToast(
        `All ${duplicateCount} file${duplicateCount !== 1 ? 's were' : ' was'} already in ${displayName}.`,
      );
    }
  } else {
    const count = data?.copiedFiles || requestedCount;
    showSuccessToast(
      `Successfully copied ${count} file${count !== 1 ? 's' : ''} to ${displayName}.`,
    );
  }
};
